<template>
  <div id="gateway-manager">
    <section class="section gateway-list">
      <card-component
        class="has-table is-fullwidth"
        title="Gateways"
        icon="raspberry-pi"
      >
        <template #headerRight>
          <router-link slot="right" to="gateway/create">
            <b-button
              v-if="hasPermission('POST')"
              type="is-primary"
              icon-left="plus"
              size="is-small"
            >
              Register Gateway
            </b-button>
          </router-link>
        </template>
        <fl-table
          is-paginated
          ref="gateway-table"
          namespace="gateway"
          title-key="key"
          :columns="gatewayColumns"
          :has-update="hasPermission('PUT')"
          :has-delete="hasPermission('DELETE')"
          :service="service"
        >
          <template #last_online="{ row }">
            <div v-if="row.last_online" class="tooltip">
              <span class="mr-2">
                {{ date(row.last_online).fromNow() }}
              </span>
              <b-tooltip
                :label="date(row.last_online).format('DD/MM/YYYY HH:mm:ss')"
              >
                <b-icon icon="eye" size="is-small"></b-icon>
              </b-tooltip>
            </div>
          </template>
          <!-- <template #action="{ row }">
            <b-button
              v-if="hasPermission('PUT')"
              :loading="row.isLoading"
              @click="resetGateway(row)"
              type="is-warning"
            >
              Readjust
            </b-button>
          </template> -->
        </fl-table>
      </card-component>
    </section>
  </div>
</template>

<script>
import dateMixin from '@/mixins/date'
import { read as readGateway, del as deleteGateway } from '@/api/gateway'

import FlTable from '@/components/table/FlTable'

export default {
  name: 'ReadGateway',
  components: { FlTable },
  mixins: [dateMixin],
  data() {
    const gatewayColumns = [
      {
        label: 'Key',
        key: 'key'
      },
      {
        label: 'Serial Number',
        key: 'serial_number'
      },
      {
        label: 'Name',
        key: 'name'
      },
      {
        label: 'Project',
        key: 'project_name'
      },
      {
        label: '',
        key: 'action',
        isSlot: true
      }
    ]

    return {
      gatewayColumns,
      service: {
        read: readGateway,
        delete: deleteGateway
      }
    }
  },
  methods: {
    hasPermission(method) {
      return this.$store.getters['auth/hasPermission']('GATEWAY', method)
    }
  }
}
</script>
